import { Flex } from '@ouster/webviz-react-components';

import AdminOverallOrgsSummary from '../../components/adminDashboard/AdminOverallOrgsSummary';
import AdminOverallSummary from '../../components/adminDashboard/AdminOverallSummary';

export default function OrganizationLookUp() {
  return (
    <Flex gap="1rem" height="100%" overflow="hidden">
      <AdminOverallSummary />
      <AdminOverallOrgsSummary />
    </Flex>
  );
}
